// extracted by mini-css-extract-plugin
export default {"component":"ComponentsList_component__ftd0C"};